import { Component, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { ActivatedRoute, Router } from "@angular/router";
import { Config } from "src/app/app-constant";
import { EncryptionService } from "src/app/service/encryption/encryption.service";
import { HttpService } from "src/app/service/http/http.service";
import { LoaderService } from "src/app/service/loader/loader.service";
import { SharedService } from "src/app/service/shared/shared.service";
import { ConfirmationPopupComponent } from "src/app/shared/popups/confirmation-popup/confirmation-popup.component";
import { IDropdownSettings } from "ng-multiselect-dropdown";
import { saveAs } from "file-saver";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-import-files",
  templateUrl: "./import-files.component.html",
  styleUrls: ["./import-files.component.scss"],
})
export class ImportFilesComponent implements OnInit {
  showImportPopup: boolean = true;
  showUAUCImportPopup: boolean = true;
  fileName = null;
  fileType = null;
  formData = new FormData();
  showBrowseBtn: boolean = false;
  moduleName: any;
  loggedInUserCompanyID: any;
  pmsYears: any = [];
  loggedInCompanyFiscalyear: any;
  selectedYearReviewCycle: any;
  selectedYear: any;
  fromYear: any;
  toYear: any;
  getMonthsByFiscalandReviewCycle: any = [];
  selectedReviewCycle: any[] = [];
  fromDate: any;
  toDate: any;
  getToMonthsByFiscalandReviewCycle: any = [];
  buttonColorName: any;
  dropdownSettings: IDropdownSettings = {};
  selectedMoths: any = [];
  loggedInUserId: any;
  selectedImportGoalsFile: any = null;
  importPath: string = "";
  selectedFile: File | null = null;
  selectedFileName: File | null = null;
  loggedInUserRole: any;
  constructor(
    public router: Router,
    public dialog: MatDialog,
    private httpService: HttpService,
    private loadingService: LoaderService,
    private config: Config,
    public sharedService: SharedService,
    private activatedroute: ActivatedRoute,
    private encryptionService: EncryptionService,
  ) {}

  ngOnInit() {
    this.buttonColorName = sessionStorage.getItem("buttonColorName");
    this.loggedInCompanyFiscalyear = sessionStorage.getItem(
      "loggedInCompanyFiscalyear",
    );
    this.loggedInUserCompanyID = Number(
      this.encryptionService.decryptData(
        sessionStorage.getItem("loggedInUserCompanyID"),
      ),
    );
    this.loggedInUserId = sessionStorage.getItem("loggedInUserId");
    this.loggedInUserRole = sessionStorage.getItem("loggedInUserRole");
    if (this.loggedInUserRole) {
      this.loggedInUserRole = this.encryptionService.decryptData(
        this.loggedInUserRole,
      );
    }
    if (this.loggedInCompanyFiscalyear) {
      this.loggedInCompanyFiscalyear = this.encryptionService.decryptData(
        this.loggedInCompanyFiscalyear,
      );
    }
    this.dropdownSettings = {
      singleSelection: false,
      idField: "id",
      textField: "name",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      itemsShowLimit: 1,
      allowSearchFilter: true,
    };
  }

  ionViewWillEnter() {
    this.activatedroute.params.subscribe((params: any) => {
      this.moduleName = params.module;
      this.selectedYear = params.year;
      if (params.module === "importgoals") {
        this.importPath = "PMS / Employee Goals / Import Goals";
        this.getpmsyearlist();
      } else if (params.module === "competencyImport") {
        this.importPath = "Competency / Competency Import";
        if (this.selectedYear) {
        }
      } else if (params.module === "positionrequisition") {
        this.importPath = "Recruitment / Position Requisition / Import";
      } else if (params.module === "candidateImport") {
        this.importPath = "Recruitment / Candidate List & Status / Import";
      }
    });

    this.showBrowseBtn = false;
  }

  backBtn() {
    if (this.moduleName == "importemployee") {
      this.router.navigate(["/home/hrportal/employeemaster"]);
    }
    if (this.moduleName == "importgoals") {
      this.router.navigate(["/home/hrportal/pms"]);
    }
    if (this.moduleName === "competencyImport") {
      this.router.navigate(["/home/hrportal/competency"]);
    }
    if (this.moduleName == "importDWM") {
      this.router.navigate(["/home/hrportal/taskmanagements"]);
    } else if (this.moduleName === "positionrequisition") {
      this.router.navigate([
        "/home/hrportal/recruitment/position-requisition-table",
      ]);
    }
    if (this.moduleName === "candidateImport") {
      // this.router.navigate(['/home/hrportal/recruitment/dashboard']);
      this.router.navigate(
        ["/home/hrportal/recruitment/candidate-list-and-status"],
        { state: { tabRouteSegment: "candidate-list-and-status" } },
      );
    }
  }
  selectFile(event: any) {
    // if (this.moduleName == 'audit-reporting') {
    this.fileName = null;
    this.fileType = null;
    this.formData = new FormData();
    const fileSizeInKB = event.target.files[0].size / 1024;
    const fileSizeInMB = fileSizeInKB / 1024;
    if (!event.target.files[0] || event.target.files[0].length == 0) {
      return;
    }
    if (
      !event.target.files[0].name.includes("xlsx") &&
      !event.target.files[0].name.includes("XLSX")
    ) {
      window.alert("File format is not supported");
      return;
    }
    if (event.target.files[0]) {
      this.fileName = event.target.files[0].name;
      this.fileType = event.target.files[0].type;
      this.formData = new FormData();
      this.formData.append("file", event.target.files[0]);
      this.formData.append("companyId", this.loggedInUserCompanyID);
      this.showBrowseBtn = true;
      const url =
        this.config.importEmployeeMaster +
        `?fileName=${this.fileName}&fileType=${this.fileType}`;
      this.loadingService.simpleLoader();
      this.httpService.submitFormService(url, this.formData).subscribe(
        (res: any) => {
          this.loadingService.dismissLoader();
          if (res?.status == false) {
            const successdialogRef = this.dialog.open(
              ConfirmationPopupComponent,
              {
                disableClose: true,
                height: "25%",
                width:
                  window.innerWidth <= 500
                    ? "90%"
                    : window.innerWidth <= 800
                      ? "50%"
                      : "30%",
                data: {
                  msg: res.message,
                  btn2: "OK",
                  btn2BgColor: "#CC0000",
                  showSuccessIcon: false,
                  showSuccessMessage: false,
                  showCloseIcon: false,
                },
              },
            );
          } else {
            const successdialogRef = this.dialog.open(
              ConfirmationPopupComponent,
              {
                disableClose: true,
                height: "25%",
                width:
                  window.innerWidth <= 500
                    ? "90%"
                    : window.innerWidth <= 800
                      ? "50%"
                      : "30%",
                data: {
                  msg: res.message,
                  btn2: "Done",
                  btn2BgColor: "#F6921E",
                  showSuccessIcon: false,
                  showSuccessMessage: true,
                  showCloseIcon: false,
                },
              },
            );
            successdialogRef.afterClosed().subscribe((result: any) => {
              this.router.navigate([
                "/home/hrportal/importHistory",
                { module: this.moduleName },
              ]);
            });
          }
        },
        (error: any) => {
          this.loadingService.dismissLoader();
        },
      );
    }
    // }
  }

  onClickDone() {
    if (this.moduleName == "importemployee") {
      this.router.navigate(["/home/hrportal/employeemaster"]);
    }
    if (this.moduleName == "importgoals") {
      this.router.navigate(["/home/hrportal/pms"]);
    }
  }

  onClickCancel() {
    if (this.moduleName == "importemployee") {
      this.router.navigate(["/home/hrportal/employeemaster"]);
    }
    if (this.moduleName == "importgoals") {
      this.router.navigate(["/home/hrportal/pms"]);
    }
  }
  importHistory() {
    this.router.navigate([
      "/home/hrportal/importHistory",
      { module: this.moduleName },
    ]);
  }
  importHistoryCompetency() {
    this.router.navigate([
      "/home/hrportal/importHistory",
      { module: this.moduleName, year: this.selectedYear },
    ]);
  }

  downloadImportFile() {
    if (this.moduleName == "importemployee") {
      this.httpService
        .callGetService(this.config.downloadEmployeeImportTemplate)
        .subscribe((data: any) => {
          if (data?.fileUrl != null) {
            var fileName = data?.fileUrl?.split(environment.downloadURL);
            saveAs(data?.fileUrl, fileName[1]);
          }
        });
    }
    if (this.moduleName == "importDWM") {
      if (
        this.loggedInUserRole == "HR Admin" ||
        this.loggedInUserRole == "Super Admin"
      ) {
        const request = {
          companyId: this.loggedInUserCompanyID,
          fromDate: null,
          hrId: this.loggedInUserId,
          toDate: null,
        };
        this.httpService
          .callPostService(
            this.config.downloadEmployeeHRImportTemplate,
            request,
          )
          .subscribe((data: any) => {
            if (data?.fileUrl != null) {
              var fileName = data?.fileUrl?.split(environment.downloadURL);
              saveAs(data?.fileUrl, fileName[1]);
            }
          });
      } else {
        const request = {
          companyId: this.loggedInUserCompanyID,
          fromDate: null,
          managerId: this.loggedInUserId,
          toDate: null,
        };
        this.httpService
          .callPostService(this.config.downloadImportDWMTemplate, request)
          .subscribe((data: any) => {
            if (data?.fileUrl != null) {
              var fileName = data?.fileUrl?.split(environment.downloadURL);
              saveAs(data?.fileUrl, fileName[1]);
            }
          });
      }
    }
  }
  getpmsyearlist() {
    const request = {
      companyId: this.loggedInUserCompanyID,
      search: "",
    };
    this.httpService
      .callPostService(this.config.getPmsYears, request)
      .subscribe((data: any) => {
        this.pmsYears = [];
        data?.data?.access?.forEach((ele: any) => {
          // var test = ele.split('_');
          let obj = {
            year: ele.fromYear + "-" + ele.toYear,
          };
          if (ele.fromYear != null && ele.toYear != null) {
            this.pmsYears.push(obj);
          }
        });
        this.pmsYears?.forEach((ele: any) => {
          const currentYear = new Date().getFullYear();
          const currentDate = new Date();
          const currentMonth = currentDate.getMonth();
          let yearValue = "";
          if (this.loggedInCompanyFiscalyear === "Jan_Dec") {
            yearValue = `${currentYear}-${currentYear}`;
          } else {
            if (this.loggedInCompanyFiscalyear === "Apr_Mar") {
              if (currentMonth < 3) {
                yearValue = `${currentYear - 1}-${currentYear}`;
              } else {
                yearValue = `${currentYear}-${currentYear + 1}`;
              }
            }
            if (this.loggedInCompanyFiscalyear === "July_Jun") {
              if (currentMonth < 6) {
                yearValue = `${currentYear - 1}-${currentYear}`;
              } else {
                yearValue = `${currentYear}-${currentYear + 1}`;
              }
            }
            if (this.loggedInCompanyFiscalyear === "Oct_Sep") {
              if (currentMonth < 9) {
                yearValue = `${currentYear - 1}-${currentYear}`;
              } else {
                yearValue = `${currentYear}-${currentYear + 1}`;
              }
            }
          }
          if (ele?.year == yearValue) {
            this.selectedYear = ele?.year;
            var test = ele?.year?.split("-");
            this.fromYear = test[0];
            this.toYear = test[1];
          }
        });
        this.getMonths(this.fromYear, this.toYear);
      });
  }
  chnageSelectYear() {
    this.fromDate = null;
    this.toDate = null;
    var year = this.selectedYear?.split("-");
    if (year?.length != 0) {
      this.fromYear = year[0];
      this.toYear = year[1];
    }
    this.getMonths(this.fromYear, this.toYear);
  }
  getMonthsByFiscalandReviewCycleForReport: any[] = [];
  getMonths(fromYear: any, toYear: any) {
    const request = {
      companyId: this.loggedInUserCompanyID,
      fromYear: fromYear,
      toYear: toYear,
    };
    this.httpService
      .callPostService(this.config.getMonths, request)
      .subscribe((data: any) => {
        this.selectedReviewCycle = [];
        this.getMonthsByFiscalandReviewCycleForReport = [];
        if (data?.data != null) {
          this.getMonthsByFiscalandReviewCycle = data.data?.months;
          data.data?.months?.forEach((ele: any) => {
            let obj = {
              id: ele,
              name: this.sharedService.transform(ele),
            };
            this.getMonthsByFiscalandReviewCycleForReport.push(obj);
          });
          this.selectedYearReviewCycle = data.data?.reviewCycle;
          const currentMonthIndex = new Date().getMonth(); // getMonth returns 0 for January, 11 for December
          let selectedIndex = 0;
          const today = new Date();
          const month = today.toLocaleString("default", { month: "long" });

          if (this.selectedYearReviewCycle == "Monthly") {
            this.getMonthsByFiscalandReviewCycle.forEach((ele: any) => {
              var checkMonth = ele?.split("-");
              if (month == checkMonth[0]) {
                this.fromDate = ele;
                this.toDate = ele;
                this.selectedReviewCycle.push({
                  id: ele,
                  name: this.sharedService.transform(ele),
                });
                this.getToMonths(this.fromDate);
              }
            });
          }

          if (
            this.selectedYearReviewCycle == "Quarterly" ||
            this.selectedYearReviewCycle == "Semi_Annually" ||
            this.selectedYearReviewCycle == "Annually"
          ) {
            for (let range of this.getMonthsByFiscalandReviewCycle) {
              const [start, end] = range?.split("-");
              const startMonthIndex = this.getMonthIndex(start);
              const endMonthIndex = this.getMonthIndex(end);

              if (
                (currentMonthIndex >= startMonthIndex &&
                  currentMonthIndex <= endMonthIndex) ||
                (startMonthIndex > endMonthIndex &&
                  (currentMonthIndex >= startMonthIndex ||
                    currentMonthIndex <= endMonthIndex))
              ) {
                this.getToMonths(range);
              }
            }
          }
        } else {
        }
      });
  }
  getToMonths(month: string) {
    const startIndex = this.getMonthsByFiscalandReviewCycle.indexOf(month);
    if (startIndex !== -1) {
      this.getToMonthsByFiscalandReviewCycle =
        this.getMonthsByFiscalandReviewCycle.slice(startIndex);
    } else {
      this.getToMonthsByFiscalandReviewCycle = [];
    }
  }

  getMonthIndex(monthName: string): number {
    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    return months.findIndex(
      (month) => month.toLowerCase() === monthName.toLowerCase(),
    );
  }
  selectAllMonths(event: any) {
    this.selectedMoths = event;
  }
  onDeSelectAllMonths() {
    this.selectedMoths = [];
  }
  downloadAllPreviousKpis() {
    const request = {
      companyId: this.loggedInUserCompanyID,
      fromYear: this.fromYear,
      months: [this.fromDate],
      toYear: this.toYear,
      userId: null,
    };
    this.httpService
      .callPostService(this.config.downloadAllPreviousKpis, request)
      .subscribe((data: any) => {
        if (data?.fileUrl != null) {
          var fileName = data?.fileUrl?.split(environment.downloadURL);
          saveAs(data?.fileUrl, fileName[1]);
        }
      });
  }
  onRemoveImportGoalsFile() {
    this.selectedImportGoalsFile = null;
    this.showBrowseBtn = false;
  }

  importFilesOfGoals(event: any) {
    this.fileName = null;
    this.fileType = null;
    this.formData = new FormData();
    const fileSizeInKB = event.target.files[0].size / 1024;
    const fileSizeInMB = fileSizeInKB / 1024;
    if (!event.target.files[0] || event.target.files[0].length == 0) {
      return;
    }
    if (
      !event.target.files[0].name.includes("xlsx") &&
      !event.target.files[0].name.includes("XLSX")
    ) {
      window.alert("File format is not supported");
      return;
    }
    if (event.target.files[0]) {
      this.fileName = event.target.files[0].name;
      this.fileType = event.target.files[0].type;
      this.selectedImportGoalsFile = event.target.files[0];
      this.showBrowseBtn = true;
    }
  }

  onClickUploadGoals() {
    if (
      this.fromYear == null ||
      this.toYear == null ||
      this.selectedMoths.length == 0 ||
      this.selectedImportGoalsFile == null
    ) {
      if (this.selectedMoths.length == 0) {
        window.alert("Please select Month");
        return;
      }
      if (this.selectedImportGoalsFile == null) {
        window.alert("Please select file");
        return;
      }
      return;
    }
    this.formData = new FormData();
    this.formData.append("file", this.selectedImportGoalsFile);
    this.formData.append("companyId", this.loggedInUserCompanyID);
    this.formData.append("fromYear", this.fromYear);
    this.formData.append("toYear", this.toYear);
    this.formData.append(
      "months",
      this.selectedMoths.map((ele: { id: any }) => ele.id),
    );
    const url =
      this.config.importFilesOfGoals +
      `?fileName=${this.fileName}&fileType=${this.fileType}`;
    this.loadingService.simpleLoader();
    this.httpService.submitFormService(url, this.formData).subscribe(
      (res: any) => {
        this.loadingService.dismissLoader();
        if (res?.status == false) {
          const successdialogRef = this.dialog.open(
            ConfirmationPopupComponent,
            {
              disableClose: true,
              height: "25%",
              width:
                window.innerWidth <= 500
                  ? "90%"
                  : window.innerWidth <= 800
                    ? "50%"
                    : "30%",
              data: {
                msg: res.message,
                btn2: "OK",
                btn2BgColor: this.buttonColorName,
                showSuccessIcon: false,
                showSuccessMessage: false,
                showCloseIcon: false,
              },
            },
          );
        } else {
          const successdialogRef = this.dialog.open(
            ConfirmationPopupComponent,
            {
              disableClose: true,
              height: "25%",
              width:
                window.innerWidth <= 500
                  ? "90%"
                  : window.innerWidth <= 800
                    ? "50%"
                    : "30%",
              data: {
                msg: res.message,
                btn2: "Done",
                btn2BgColor: this.buttonColorName,
                showSuccessIcon: true,
                showSuccessMessage: false,
                showCloseIcon: false,
              },
            },
          );
          successdialogRef.afterClosed().subscribe((result: any) => {
            this.router.navigate([
              "/home/hrportal/importHistory",
              { module: this.moduleName },
            ]);
          });
        }
      },
      (error: any) => {
        this.loadingService.dismissLoader();
      },
    );
  }

  //Competency Import Content Below

  downloadCompetencyImportFile() {
    this.httpService
      .callGetService(
        this.config.getImportOfCompetency +
          this.loggedInUserCompanyID +
          "/" +
          this.selectedYear,
      )
      .subscribe(
        (data: any) => {
          if (data?.data != null) {
            var fileName = data?.data?.split(environment.downloadURL);
            saveAs(data?.data, fileName[1]);
          }
        },
        (error) => {},
      );
  }

  uploadCompetencyFile() {
    if (!this.selectedFile) {
      alert("Please select a file first.");
      return;
    }
    if (!this.selectedFile.name.match(/\.(xlsx)$/i)) {
      alert("File format is not supported");
      return;
    }
    const maxSizeInMB = 5;
    const fileSizeInMB = this.selectedFile.size / (1024 * 1024);
    if (fileSizeInMB > maxSizeInMB) {
      alert(`File size exceeds ${maxSizeInMB} MB`);
      return;
    }
    const formData = new FormData();
    formData.append("file", this.selectedFile);
    formData.append("companyId", this.loggedInUserCompanyID);
    formData.append("yearRange", this.selectedYear);
    const url = this.config.importFileCompetencyImport;
    this.loadingService.simpleLoader();
    this.httpService.submitFormService(url, formData).subscribe(
      (response: any) => {
        this.loadingService.dismissLoader();
        this.showBrowseBtn = true;
        const successDialogRef = this.dialog.open(ConfirmationPopupComponent, {
          disableClose: true,
          height: "25%",
          width:
            window.innerWidth <= 500
              ? "90%"
              : window.innerWidth <= 800
                ? "50%"
                : "30%",
          data: {
            msg: response.message,
            btn2: "Done",
            btn2BgColor: "#F6921E",
            showSuccessIcon: false,
            showSuccessMessage: true,
            showCloseIcon: false,
          },
        });
        successDialogRef.afterClosed().subscribe(() => {
          this.router.navigate([
            "/home/hrportal/importHistory",
            { module: this.moduleName },
          ]);
        });
      },
      (error: any) => {
        this.loadingService.dismissLoader();

        // Show error dialog
        this.dialog.open(ConfirmationPopupComponent, {
          disableClose: true,
          height: "25%",
          width:
            window.innerWidth <= 500
              ? "90%"
              : window.innerWidth <= 800
                ? "50%"
                : "30%",
          data: {
            msg: "An error occurred while uploading the file. Please try again.",
            btn2: "OK",
            btn2BgColor: "#CC0000",
            showSuccessIcon: false,
            showSuccessMessage: false,
            showCloseIcon: false,
          },
        });
      },
    );
  }

  selectCompetencyFile(event: any) {
    // Reset the selected file and file name
    this.selectedFileName = null;
    this.selectedFile = null;

    // Check if a file is selected
    if (!event.target.files[0] || event.target.files[0].length === 0) {
      return;
    }

    // Get the file size in KB and MB (for validation if needed)
    const fileSizeInKB = event.target.files[0].size / 1024;
    const fileSizeInMB = fileSizeInKB / 1024;

    // Validate the file type by checking the file extension
    if (
      !event.target.files[0].name.includes("xlsx") &&
      !event.target.files[0].name.includes("XLSX")
    ) {
      window.alert("File format is not supported");
      return;
    }

    // If the file is valid, set the selected file and file name
    this.selectedFile = event.target.files[0];
    this.selectedFileName = event.target.files[0].name;
    this.showBrowseBtn = true;

    // Optional: Log the selected file information for debugging
  }

  completeCompetencyUpload() {}

  showCompetencyHistory() {
    this.router.navigate(["/home/hrportal/coompetencyHistory"]);
  }

  selectImportDWMFile(event: any) {
    this.fileName = null;
    this.fileType = null;
    this.formData = new FormData();
    const fileSizeInKB = event.target.files[0].size / 1024;
    const fileSizeInMB = fileSizeInKB / 1024;
    if (!event.target.files[0] || event.target.files[0].length == 0) {
      return;
    }
    if (
      !event.target.files[0].name.includes("xlsx") &&
      !event.target.files[0].name.includes("XLSX")
    ) {
      window.alert("File format is not supported");
      return;
    }
    if (event.target.files[0]) {
      this.fileName = event.target.files[0].name;
      this.fileType = event.target.files[0].type;
      this.formData = new FormData();
      this.formData.append("file", event.target.files[0]);
      this.formData.append("companyId", this.loggedInUserCompanyID);
      this.showBrowseBtn = true;
      let url;
      if (
        this.loggedInUserRole == "HR Admin" ||
        this.loggedInUserRole == "Super Admin"
      ) {
        url =
          this.config.ImportHrFile +
          `?fileName=${this.fileName}&fileType=${this.fileType}`;
      } else {
        url =
          this.config.ImportDWMFile +
          `?fileName=${this.fileName}&fileType=${this.fileType}`;
      }

      this.loadingService.simpleLoader();
      this.httpService
        .submitFormService(url, this.formData)
        .subscribe((res: any) => {
          this.loadingService.dismissLoader();
          if (res?.status == false) {
            this.loadingService.dismissLoader();
            const successdialogRef = this.dialog.open(
              ConfirmationPopupComponent,
              {
                disableClose: true,
                height: "25%",
                width:
                  window.innerWidth <= 500
                    ? "90%"
                    : window.innerWidth <= 800
                      ? "50%"
                      : "30%",
                data: {
                  msg: res.message,
                  btn2: "OK",
                  btn2BgColor: "#CC0000",
                  showSuccessIcon: false,
                  showSuccessMessage: false,
                  showCloseIcon: false,
                },
              },
            );
            successdialogRef.afterClosed().subscribe((result: any) => {
              this.router.navigate([
                "/home/hrportal/importHistory",
                { module: this.moduleName },
              ]);
            });
          } else {
            this.loadingService.dismissLoader();
            const successdialogRef = this.dialog.open(
              ConfirmationPopupComponent,
              {
                disableClose: true,
                height: "25%",
                width:
                  window.innerWidth <= 500
                    ? "90%"
                    : window.innerWidth <= 800
                      ? "50%"
                      : "30%",
                data: {
                  msg: res.message,
                  btn2: "Done",
                  btn2BgColor: "#F6921E",
                  showSuccessIcon: false,
                  showSuccessMessage: true,
                  showCloseIcon: false,
                },
              },
            );
            successdialogRef.afterClosed().subscribe((result: any) => {
              this.router.navigate([
                "/home/hrportal/importHistory",
                { module: this.moduleName },
              ]);
            });
          }
        });
      this.loadingService.dismissLoader();
    }
  }
  selectedPositionRequisitionFile: File | null = null;
  selectedPositionRequisitionFileName: string | null = null;

  downloadPositionRequisitionTemplate() {
    // const url = this.config.downloadPositionRequisitionTemplate + `/${this.loggedInUserCompanyID}`;
    // this.httpService.callGetService(url).subscribe((data: any) => {
    //   if (data?.fileUrl) {
    //     const fileName = data.fileUrl?.split(environment.downloadURL);
    //     saveAs(data.fileUrl, fileName[1]);
    //   }
    // });
  }

  selectPositionRequisitionFile(event: any): void {
    this.selectedPositionRequisitionFile = null;
    this.selectedPositionRequisitionFileName = null;
    this.showBrowseBtn = false;

    const file = event.target.files[0];
    if (!file) return;

    const fileExtension = file.name.split(".").pop()?.toLowerCase();
    if (fileExtension !== "xlsx") {
      alert("Please select a valid Excel file (.xlsx)");
      return;
    }

    this.selectedPositionRequisitionFile = file;
    this.selectedPositionRequisitionFileName = file.name;
    this.showBrowseBtn = true;
  }

  uploadPositionRequisitionFile(): void {
    if (!this.selectedPositionRequisitionFile) {
      alert("Please select a file.");
      return;
    }

    const maxSizeInMB = 5;
    const fileSize = this.selectedPositionRequisitionFile.size / (1024 * 1024);
    if (fileSize > maxSizeInMB) {
      alert(`File size exceeds ${maxSizeInMB} MB`);
      return;
    }

    const formData = new FormData();
    formData.append("file", this.selectedPositionRequisitionFile);
    formData.append("companyId", this.loggedInUserCompanyID);

    // const url = this.config.importPositionRequisition;

    // this.loadingService.simpleLoader();
    // this.httpService.submitFormService(url, formData).subscribe(
    //   (response: any) => {
    //     this.loadingService.dismissLoader();
    //     const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
    //       disableClose: true,
    //       height: '25%',
    //       width: window.innerWidth <= 500 ? '90%' : window.innerWidth <= 800 ? '50%' : '30%',
    //       data: {
    //         msg: response.message,
    //         btn2: 'Done',
    //         btn2BgColor: '#F6921E',
    //         showSuccessIcon: true,
    //         showSuccessMessage: false,
    //         showCloseIcon: false
    //       }
    //     });
    //     dialogRef.afterClosed().subscribe(() => {
    //       this.router.navigate(['/home/hrportal/importHistory', { module: this.moduleName }]);
    //     });
    //   },
    //   (error: any) => {
    //     this.loadingService.dismissLoader();
    //     this.dialog.open(ConfirmationPopupComponent, {
    //       disableClose: true,
    //       height: '25%',
    //       width: window.innerWidth <= 500 ? '90%' : window.innerWidth <= 800 ? '50%' : '30%',
    //       data: {
    //         msg: 'An error occurred while uploading. Please try again.',
    //         btn2: 'OK',
    //         btn2BgColor: '#CC0000',
    //         showSuccessIcon: false,
    //         showSuccessMessage: false,
    //         showCloseIcon: false
    //       }
    //     });
    //   }
    // );
  }
  selectedCandidateFile: File | null = null;
  selectedCandidateFileName: string | null = null;

  downloadCandidateTemplate() {
    // this.httpService.callGetService(this.config.downloadCandidateImportTemplate).subscribe(
    //   (data: any) => {
    //     if (data?.fileUrl != null) {
    //       const fileName = data?.fileUrl?.split(environment.downloadURL);
    //       saveAs(data?.fileUrl, fileName[1]);
    //     }
    //   }
    // );
  }

  selectCandidateFile(event: any) {
    this.selectedCandidateFileName = null;
    this.selectedCandidateFile = null;

    if (!event.target.files[0]) return;

    const file = event.target.files[0];
    if (!file.name.toLowerCase().endsWith(".xlsx")) {
      window.alert("File format is not supported");
      return;
    }

    this.selectedCandidateFile = file;
    this.selectedCandidateFileName = file.name;
    this.showBrowseBtn = true;
  }

  uploadCandidateFile() {
    if (!this.selectedCandidateFile) {
      alert("Please select a file.");
      return;
    }

    const formData = new FormData();
    formData.append("file", this.selectedCandidateFile);
    formData.append("companyId", this.loggedInUserCompanyID);

    this.loadingService.simpleLoader();
    // this.httpService.submitFormService(this.config.uploadCandidateImportFile, formData).subscribe({
    //   next: (res: any) => {
    //     this.loadingService.dismissLoader();
    //     this.dialog.open(ConfirmationPopupComponent, {
    //       disableClose: true,
    //       height: '25%',
    //       width: '30%',
    //       data: {
    //         msg: res.message,
    //         btn2: 'Done',
    //         btn2BgColor: '#F6921E',
    //         showSuccessIcon: true,
    //         showSuccessMessage: false,
    //         showCloseIcon: false
    //       }
    //     }).afterClosed().subscribe(() => {
    //       this.router.navigate(['/home/hrportal/importHistory', { module: 'candidateImport' }]);
    //     });
    //   },
    //   error: () => {
    //     this.loadingService.dismissLoader();
    //     this.dialog.open(ConfirmationPopupComponent, {
    //       disableClose: true,
    //       height: '25%',
    //       width: '30%',
    //       data: {
    //         msg: 'Upload failed. Please try again.',
    //         btn2: 'OK',
    //         btn2BgColor: '#CC0000',
    //         showSuccessIcon: false,
    //         showSuccessMessage: false,
    //         showCloseIcon: false
    //       }
    //     });
    //   }
    // });
  }
}
